module.exports = __webpack_public_path__ + "img/Group 47.e81bd5ca.svg";